enum RFPSortBy {
  RFPName = 'rfpName',
  SystemSize = 'systemSize',
  LastUpdated = 'lastUpdated',
}

export default RFPSortBy;
